import { forwardRef, createElement } from 'react';

function IconInventoryMatrix(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M19.25 3c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0119.25 21H4.75A1.75 1.75 0 013 19.25V4.75C3 3.784 3.784 3 4.75 3h14.5zm-8 12.25H4.5v4a.25.25 0 00.193.243l.057.007h6.5v-4.25zm8.25-5h-6.75v9.25h6.5a.25.25 0 00.243-.193l.007-.057v-9zm-2.996 2.383c.419 0 .71.26.755.67l.007.115v3.945c0 .442-.23.688-.637.688-.373 0-.597-.207-.635-.573l-.006-.115v-3.511h-.015l-.41.277c-.204.129-.313.168-.442.168a.431.431 0 01-.445-.445c0-.165.086-.314.256-.445l.091-.063.637-.426c.305-.195.582-.285.844-.285zM11.25 4.5h-6.5a.25.25 0 00-.243.193L4.5 4.75v9h6.75V4.5zM7.883 6.57c1.074 0 1.86.657 1.86 1.551 0 .505-.224.954-.764 1.519l-1.268 1.282v.055h1.625c.363 0 .59.195.59.515 0 .285-.18.468-.484.502L9.336 12H6.664c-.379 0-.629-.215-.629-.543 0-.208.102-.392.399-.699l.12-.121 1.352-1.39c.418-.427.594-.708.594-1.005 0-.383-.277-.64-.688-.64-.332 0-.574.168-.746.515-.171.266-.32.367-.546.367-.31 0-.524-.21-.524-.507 0-.727.82-1.407 1.887-1.407zM19.25 4.5h-6.5v4.25h6.75v-4a.25.25 0 00-.193-.243L19.25 4.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var InventoryMatrix = /*#__PURE__*/forwardRef(IconInventoryMatrix);

export default InventoryMatrix;
//# sourceMappingURL=InventoryMatrix.js.map
